import React from 'react';
import TimeOfUse from './TimeOfUse';
import SlabBased from './SlabBased';
import FlatRate from './FlatRate';
import { useCurrency } from '@shared/selectors/globalSelectors';
import { formatMonthDay } from '@shared/utils/dateUtils';

export default function Seasonal({ seasons }: { seasons: any[] }) {
  const currency=useCurrency();
  
  return (
    <div className="space-y-6">
      {seasons.map((season, index) => {
        const startDate = formatMonthDay(season.startTime ?? season.startDate ?? 'MM-DD');
        const endDate = formatMonthDay(season.endTime ?? season.endDate ?? 'MM-DD');
        const dateRange = `${startDate} \u2192 ${endDate}`;

        const subRateType = season.rate_type ?? season.rateType; 
        
        let typeDisplay = "NA";
        if (subRateType === 3) typeDisplay = "Flat Rate";
        if (subRateType === 4) typeDisplay = "Slab Based";
        if (subRateType === 5) typeDisplay = "Time of Use";
        if (subRateType === 7) typeDisplay = "Fixed";

        let content = null;
        if (subRateType === 5) {
          content = <TimeOfUse slots={season.structure || []} />;
        } else if (subRateType === 4) {
          content = <SlabBased slabs={season.structure || []} variant="table" />;
        } else if (subRateType === 3 || subRateType === 7) {
          content = <FlatRate data={season.structure} />;
        }

        const nameLower = (season.name || season.seasonName || '').toLowerCase();
        let nameBadgeClass = "border-slate-200 bg-slate-50 text-slate-700";
        if (nameLower === 'summer') {
          nameBadgeClass = "border-orange-200 bg-orange-50 text-orange-700";
        } else if (nameLower === 'winter') {
          nameBadgeClass = "border-blue-200 bg-blue-50 text-blue-700";
        } else if (nameLower === 'shoulder') {
          nameBadgeClass = "border-slate-200 bg-slate-50 text-slate-700";
        }

        return (
          <div key={index} className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
            {/* Badges row */}
            <div className="flex items-center gap-3 mb-6">
              <span className={`inline-flex items-center rounded-full border px-4 py-1.5 text-sm font-semibold capitalize ${nameBadgeClass}`}>
                {season.name || season.seasonName || 'NA'}
              </span>
              <span className="inline-flex items-center rounded-full bg-slate-100 px-4 py-1.5 text-sm font-mono font-medium text-slate-600">
                {dateRange}
              </span>
              <span className="inline-flex items-center rounded-full border border-cyan-200 bg-cyan-50 px-4 py-1.5 text-sm font-semibold text-cyan-700">
                {typeDisplay}
              </span>
            </div>

            {/* Content */}
            <div className="pt-2">
              {content}
            </div>
          </div>
        );
      })}
    </div>
  );
}
